// extracted by mini-css-extract-plugin
module.exports = {"main":"AboutUs_main__38vEX","subTitle":"AboutUs_subTitle__3ZRy3","button":"AboutUs_button__ZBqZo","strong":"AboutUs_strong__W2Umr","p":"AboutUs_p__gJuVs"};